import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import TeamBuildingComponents from "./TeamBuildind";
import VRSection from "./vrBackground";



export default function Team() {
  return (
    <>
      <Navbar />

      <section id="home" className="relative w-full min-h-screen overflow-hidden -mt-36">
        {/* Background Image */}
        <div className="absolute inset-0 bg-white z-0" />


        {/* Foreground content with black transparent background */}
        <div className="relative z-10">
          <div id="team-building">
            <TeamBuildingComponents />
          </div>
        </div>
      </section>

      <div id="vr-section">
        <VRSection />
      </div>

      <Footer />
    </>
  );
}
